<template>
  <div>
    <ok-table
      ref="datatable"
      :config="config"
    >
      <template
        v-if="noQueue"
        slot="empty-state"
      >
        <div class="w-100 d-flex flex-column align-items-center">
          <p class="mt-1  font-weight-bold">
            {{ $t('queues.no-one') }}
          </p>
          <p
            class="text-center font-weight-bold"
            style="max-width: 400px"
          >
            {{ $t('queues.no-one-hint') }}
            <a
              class="text-primary"
              @click.prevent="openAddModal"
            >{{ $t('queues.or-from-here') }}</a>
          </p>
        </div>
      </template>
      <template
        slot="buttons"
      >
        <b-button
          variant="dark"
          size="lg"
          @click="openAddModal()"
        >
          {{ $t('queues.add') }}
        </b-button>
      </template>
      <template
        slot="status-column"
        slot-scope="{props}"
      >
        <b-badge :variant="(props.row.status===1)?'success':(props.row.status===2)?'danger':'primary'">
          {{ statusString(props.row) }}
        </b-badge>

      </template>
      <template
        slot="actions-column"
        slot-scope="{props}"
      >
        <custom-actions>
          <template v-for="action in actions">
            <b-dropdown-item
              v-if="action.show.includes(props.row.status)"
              :key="action.action"
              :disabled="isDisabled(props.row,action.action)"
              @click.stop="handleAction(props.row,action.action)"
            >
              <feather-icon
                :icon="action.icon"
                class="mr-50"
              />
              <span>{{ $t(action.label) }}</span>
            </b-dropdown-item>
          </template>
        </custom-actions>
      </template>
    </ok-table>
    <assign-table-modal
      v-model="showTablesModal"
      :item="selectedQueue"
      @updated="refreshTable"
      @close="closeModal"
    />
    <add-queues-modal
      v-model="showAddModal"
      @updated="refreshTable"
    />
  </div>
</template>

<script>
import { BDropdownItem, BBadge, BButton } from 'bootstrap-vue'
import QueuesConfig from './config/queues-table-config'
import AssignTableModal from '@/views/admin/management/queues/components/AssignTableModal'
import CustomActions from '@/@okmenu/components/tables/ok-table/components/CustomActions'
import { QueuesStatuses, QueuesActions } from './config/queues-options'
import AddQueuesModal from '@/views/admin/management/queues/components/AddQueueModal'

export default {
  components: {
    AddQueuesModal,
    CustomActions,
    AssignTableModal,
    OkTable: () => import(/* webpackChunkName: "ok-table" */ '@/@okmenu/components/tables/ok-table/OkTable'),
    BDropdownItem,
    BBadge,
    BButton,
  },
  props: {
    noQueue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      config: QueuesConfig,
      user: null,
      editUser: false,
      showTablesModal: false,
      selectedQueue: {},
      actions: QueuesActions,
      status: QueuesStatuses,
      showAddModal: false,
    }
  },
  watch: {
    currentBranchId() {
      this.resetModalForm()
    },
  },
  mounted() {
    this.$bus.$on('new-queue', this.loadItems)
  },
  beforeDestroy() {
    this.$bus.$off('new-queue', this.loadItems)
  },
  methods: {
    loadItems() {
      this.$refs.datatable.loadItems()
    },
    openAddModal() {
      this.showAddModal = true
    },
    handleAction(data, type) {
      this[`handle${type}`](data)
    },
    handleComplete(data) {
      this.showTablesModal = true
      this.selectedQueue = data
    },
    async handleCancel(data) {
      await this.update(data.id, this.status.QUEUE_CANCELLED)
    },
    async update(id, status) {
      const response = await this.$store.dispatch('queues/UPDATE', { status, id })
      if (response?.response === 202) {
        this.refreshTable()
        this.$notifySuccess(response.message)
      } else {
        this.$notifyError(response.message)
      }
    },
    async handleBackWaiting(data) {
      if (new Date() > new Date(data.disable_after)) {
        this.refreshTable()
        this.$notifyError(this.$t('queues.cant-change-status'))
        return false
      }
      await this.update(data.id, this.status.QUEUE_WAITING)
      return true
    },
    statusString(row) {
      switch (row.status) {
        case 1: return this.$t('queues.completed')
        case 2: return this.$t('queues.cancelled')
        default: return this.$t('queues.pending')
      }
    },
    closeModal() {
      this.selectedQueue = {}
      this.showTablesModal = false
    },
    refreshTable() {
      this.showAddModal = false
      this.closeModal()
      this.$refs.datatable.loadItems()
    },
    isDisabled(row, action) {
      if (action !== 'BackWaiting') return false
      if (new Date() > new Date(row.disable_after)) return true
      return false
    },
  },
}
</script>
